import { render, staticRenderFns } from "./AddQuestionModal.vue?vue&type=template&id=c49a205e&scoped=true"
import script from "./AddQuestionModal.vue?vue&type=script&lang=js"
export * from "./AddQuestionModal.vue?vue&type=script&lang=js"
import style0 from "./AddQuestionModal.vue?vue&type=style&index=0&id=c49a205e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c49a205e",
  null
  
)

export default component.exports